// @ts-ignore
export const isDev = process.env.NODE_ENV === "development";

// @ts-ignore
export const isProd = process.env.NODE_ENV === "production";
